<!-- Header / Brand Logo -->
<div class="h-14 flex items-center justify-between px-3.5 border-b border-slate-200 dark:border-slate-800 shrink-0">
  <div class="flex items-center gap-2.5 min-w-0">
    <div
      class="w-8 h-8 rounded-md bg-slate-900 dark:bg-slate-800 flex items-center justify-center text-white shrink-0 shadow-xs">
      <i class="pi pi-chart-line text-sm"></i>
    </div>
    @if (showNames) {
    <span
      class="text-sm font-semibold text-slate-900 dark:text-slate-100 tracking-tight whitespace-nowrap overflow-hidden transition-all duration-200">
      Seamless Business Platform
    </span>
    }
  </div>

  <!-- Mobile Close Button -->
  @if (mobileOpen) {
  <button type="button" (click)="closeMobile.emit()"
    class="md:hidden flex items-center justify-center w-8 h-8 rounded-md text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800 border-none bg-transparent cursor-pointer outline-none">
    <i class="pi pi-times text-xs"></i>
  </button>
  }
</div>

<!-- Navigation Menu List -->
<nav class="flex-1 py-3 overflow-y-auto px-2.5 space-y-1">
  <!-- Dashboard Link -->
  <a routerLink="/dashboard" title="Dashboard"
    routerLinkActive="bg-slate-900 !text-white dark:!bg-slate-100 dark:!text-slate-900 font-semibold shadow-xs"
    [routerLinkActiveOptions]="{ exact: true }"
    class="flex items-center px-3 py-2.5 rounded-md hover:bg-slate-100/70 dark:hover:bg-slate-800/50 hover:text-slate-900 dark:hover:text-white transition-all group gap-3 text-slate-700 dark:text-slate-300 no-underline cursor-pointer text-[14px]"
    (click)="closeMobile.emit()">
    <i class="pi pi-home text-base transition-transform group-hover:scale-105 shrink-0"></i>
    @if (showNames) {
    <span class="tracking-normal transition-opacity duration-200 font-medium whitespace-normal leading-tight">
      Dashboard
    </span>
    }
  </a>

  @for (item of menuItems(); track item.label) {
  @if (item.children) {
  <div class="flex flex-col">
    <!-- Parent Link with Submenu -->
    <div [attr.title]="item.label"
      [ngClass]="isSubmenuActive(item) ? 'bg-slate-200 dark:bg-slate-800 text-slate-900 dark:text-white font-semibold border border-slate-300/40 dark:border-slate-700/40' : 'text-slate-700 dark:text-slate-300'"
      class="flex items-center justify-between px-3 py-2.5 rounded-md hover:bg-slate-100/70 dark:hover:bg-slate-800/50 hover:text-slate-900 dark:hover:text-white transition-all group gap-3 no-underline cursor-pointer select-none text-[14px]"
      (click)="toggleSubmenu(item.label)">
      <div class="flex items-center gap-3 min-w-0 flex-1">
        <i [class]="item.icon" class="text-base transition-transform group-hover:scale-105 shrink-0"
          [ngClass]="{'text-slate-900 dark:text-white': isSubmenuActive(item)}"></i>
        @if (showNames) {
        <span
          class="tracking-normal transition-opacity duration-200 font-medium whitespace-normal leading-tight flex-1">
          {{ item.label }}
        </span>
        }
      </div>
      @if (showNames) {
      <i class="pi text-[10px] transition-transform duration-200 shrink-0 ml-1" [ngClass]="{
               'text-slate-400 dark:text-slate-500 group-hover:text-slate-700 dark:group-hover:text-slate-300': !isSubmenuActive(item),
               'text-slate-700 dark:text-slate-200': isSubmenuActive(item),
               'pi-chevron-down': !expandedMenus[item.label],
               'pi-chevron-up': expandedMenus[item.label]
             }"></i>
      }
    </div>

    <!-- Submenu Children -->
    @if (showNames && expandedMenus[item.label]) {
    <div
      class="mt-1 pl-3.5 pr-1 space-y-0.5 transition-all duration-200 border-l border-slate-200 dark:border-slate-800 ml-4">
      @for (child of item.children; track child.label) {
      <a [routerLink]="[child.route]" [attr.title]="child.label"
        routerLinkActive="bg-slate-900 !text-white dark:!bg-slate-100 dark:!text-slate-900 font-semibold shadow-xs"
        [routerLinkActiveOptions]="{ exact: true }"
        class="flex items-center px-2.5 py-2 rounded-md hover:bg-slate-100/70 dark:hover:bg-slate-800/50 hover:text-slate-900 dark:hover:text-white transition-all group gap-2.5 text-slate-600 dark:text-slate-400 no-underline text-[13.5px]"
        (click)="closeMobile.emit()">
        <i [class]="child.icon" class="text-sm shrink-0 transition-transform group-hover:scale-105"></i>
        <span class="whitespace-normal leading-tight font-medium flex-1">{{ child.label }}</span>
      </a>
      }
    </div>
    }
  </div>
  } @else {
  <!-- Standard Menu Link -->
  <a [routerLink]="[item.route]" [attr.title]="item.label"
    routerLinkActive="bg-slate-900 !text-white dark:!bg-slate-100 dark:!text-slate-900 font-semibold shadow-xs"
    [routerLinkActiveOptions]="{ exact: true }"
    class="flex items-center px-3 py-2.5 rounded-md hover:bg-slate-100/70 dark:hover:bg-slate-800/50 hover:text-slate-900 dark:hover:text-white transition-all group gap-3 text-slate-700 dark:text-slate-300 no-underline text-[14px]"
    (click)="closeMobile.emit()">
    <i [class]="item.icon" class="text-base transition-transform group-hover:scale-105 shrink-0"></i>
    @if (showNames) {
    <span class="tracking-normal transition-opacity duration-200 font-medium whitespace-normal leading-tight flex-1">
      {{ item.label }}
    </span>
    }
  </a>
  }
  }
</nav>

<!-- Sidebar Footer -->
<div class="h-10 border-t border-slate-200 dark:border-slate-800 flex items-center px-3.5 shrink-0 transition-all">
  @if (showNames) {
  <div class="w-full flex items-center justify-between">
    <span class="text-xs font-medium text-slate-500 dark:text-slate-400">Version</span>
    <span
      class="text-[11px] font-semibold text-slate-600 dark:text-slate-400 bg-slate-100 dark:bg-slate-800 px-1.5 py-0.5 rounded border border-slate-200 dark:border-slate-700 shrink-0">v1.0.0</span>
  </div>
  } @else {
  <div class="w-full flex items-center justify-center" title="SEAMLESS v1.0.0">
    <i class="pi pi-info-circle text-slate-400 dark:text-slate-500 text-sm"></i>
  </div>
  }
</div>